import { useLocation } from "react-router";
import { singleSignatureWorkflow } from "src/config";
import { useFeatureToggleWhenReady } from "src/hooks/use-feature-toggle";
import DashboardDocSignaturePreviewNew from "./therapist-dashboar-doc-preview-new";
import TherapistDashboardDocSignature from "./therapist-dashboard-doc-signature";

const SignaturePreviewWrapper = () => {
  const [isSingleSignatureWorkflow] = useFeatureToggleWhenReady(
    singleSignatureWorkflow,
    'ENTERPRISE'
  );

  const location = useLocation();

  if(!isSingleSignatureWorkflow) {
    return <TherapistDashboardDocSignature />
  }

  if(location.state.document.isReformSignature === false) {
    return <TherapistDashboardDocSignature />
  }

  return <DashboardDocSignaturePreviewNew />
}

export default SignaturePreviewWrapper